/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mission Impact API
 * OpenAPI spec version: v1
 */
export interface AddSourceRequest {
  config?: SourceConfigRequest;
}

export interface AddSourceResponse {
  sourceId?: string;
}

export type AddSourceTableRequest =
  | AddDataverseSourceTableRequest
  | AddBusinessCentralSourceTableRequest
  | AddSalesforceSourceTableRequest;

export interface AddSourceTableResponse {
  sourceTableId?: string;
}

export interface AddTargetRequest {
  config?: TargetConfigRequest;
  /** @nullable */
  agentId?: string | null;
}

export interface AddTargetResponse {
  targetId?: string;
}

export type AgentDtoStatus = (typeof AgentDtoStatus)[keyof typeof AgentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgentDtoStatus = {
  Unregistered: 'Unregistered',
  Active: 'Active',
  Inactive: 'Inactive',
} as const;

export type AgentDtoHealthState = (typeof AgentDtoHealthState)[keyof typeof AgentDtoHealthState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgentDtoHealthState = {
  Online: 'Online',
  Suspect: 'Suspect',
  Offline: 'Offline',
} as const;

/**
 * @nullable
 */
export type AgentDtoLastHealthCheckOutcome =
  | (typeof AgentDtoLastHealthCheckOutcome)[keyof typeof AgentDtoLastHealthCheckOutcome]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgentDtoLastHealthCheckOutcome = {
  Healthy: 'Healthy',
  Unresponsive: 'Unresponsive',
  Busy: 'Busy',
  Inconclusive: 'Inconclusive',
} as const;

export interface AgentDto {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  orgId: string;
  /** @minLength 1 */
  name: string;
  status: AgentDtoStatus;
  version?: string;
  /** @nullable */
  lastHeartbeatUtc?: string | null;
  /** @nullable */
  registeredAtUtc?: string | null;
  /** @minLength 1 */
  createdUtc: string;
  /** @nullable */
  updatedUtc?: string | null;
  /** @nullable */
  lastErrorUtc?: string | null;
  healthState: AgentDtoHealthState;
  /** @nullable */
  offlineSinceUtc?: string | null;
  /** @nullable */
  lastHealthCheckStartedUtc?: string | null;
  /** @nullable */
  lastHealthCheckCompletedUtc?: string | null;
  /** @nullable */
  lastHealthCheckOutcome?: AgentDtoLastHealthCheckOutcome;
  /** @nullable */
  lastHealthCheckDetail?: string | null;
  workerCount: number;
}

export interface AgentLogEntryDto {
  level?: string;
  source?: string;
  message?: string;
  timestampUtc?: string;
  serverReceivedAtUtc?: string;
}

export interface AgentLogEntryRequest {
  entryId?: string;
  level?: string;
  message?: string;
  timestampUtc?: string;
}

export interface AgentLogsPaginatedResult {
  items?: AgentLogEntryDto[];
  continuationToken?: string;
  hasMore?: boolean;
}

/**
 * @nullable
 */
export type AgentTaskDtoErrorCode =
  | (typeof AgentTaskDtoErrorCode)[keyof typeof AgentTaskDtoErrorCode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgentTaskDtoErrorCode = {
  Success: 'Success',
  BadRequest: 'BadRequest',
  Unauthorized: 'Unauthorized',
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  Conflict: 'Conflict',
  Gone: 'Gone',
  PayloadTooLarge: 'PayloadTooLarge',
  UnsupportedMediaType: 'UnsupportedMediaType',
  InternalServerError: 'InternalServerError',
  DatabaseError: 'DatabaseError',
  ServiceUnavailable: 'ServiceUnavailable',
  DataExtractionFailed: 'DataExtractionFailed',
  SchemaExtractionFailed: 'SchemaExtractionFailed',
  CheckpointRetrievalFailed: 'CheckpointRetrievalFailed',
  TargetLoadFailed: 'TargetLoadFailed',
  DataTransformationFailed: 'DataTransformationFailed',
  SourceConnectionFailed: 'SourceConnectionFailed',
  TargetConnectionFailed: 'TargetConnectionFailed',
  RateLimitExceeded: 'RateLimitExceeded',
  TimeoutError: 'TimeoutError',
  NetworkError: 'NetworkError',
  OrchestrationTimeout: 'OrchestrationTimeout',
  OrchestrationCancelled: 'OrchestrationCancelled',
  OrchestrationOrphaned: 'OrchestrationOrphaned',
  InvalidConfiguration: 'InvalidConfiguration',
  TargetInitialSyncConflict: 'TargetInitialSyncConflict',
  DataverseCallFailed: 'DataverseCallFailed',
  DataverseAuthenticationFailed: 'DataverseAuthenticationFailed',
  DataverseChangeTrackingNotEnabled: 'DataverseChangeTrackingNotEnabled',
  DataverseEntityNotFound: 'DataverseEntityNotFound',
  DataversePermissionDenied: 'DataversePermissionDenied',
  DataverseInvalidEntityConfiguration: 'DataverseInvalidEntityConfiguration',
  DataverseSecretRetrievalFailed: 'DataverseSecretRetrievalFailed',
  DataverseHostnameNotFound: 'DataverseHostnameNotFound',
  DataverseInvalidUrl: 'DataverseInvalidUrl',
  DataverseInvalidClientId: 'DataverseInvalidClientId',
  DataverseInvalidClientSecret: 'DataverseInvalidClientSecret',
  DataverseInvalidAppRegistration: 'DataverseInvalidAppRegistration',
  DataverseInvalidTenant: 'DataverseInvalidTenant',
  DataverseConnectionFailed: 'DataverseConnectionFailed',
  DataversePermissionDeniedMetadata: 'DataversePermissionDeniedMetadata',
  DataversePermissionDeniedData: 'DataversePermissionDeniedData',
  DataverseVersionStampExpired: 'DataverseVersionStampExpired',
  DataverseInvalidRequest: 'DataverseInvalidRequest',
  BcCallFailed: 'BcCallFailed',
  BcAuthenticationFailed: 'BcAuthenticationFailed',
  BcInvalidClientId: 'BcInvalidClientId',
  BcInvalidClientSecret: 'BcInvalidClientSecret',
  BcEnvironmentNotFound: 'BcEnvironmentNotFound',
  BcPermissionDenied: 'BcPermissionDenied',
  BcEntityNotFound: 'BcEntityNotFound',
  BcInvalidRequest: 'BcInvalidRequest',
  BcTenantUnavailable: 'BcTenantUnavailable',
  BcCompanyNotFound: 'BcCompanyNotFound',
  BcNotFound: 'BcNotFound',
  BcEntityNotSupported: 'BcEntityNotSupported',
  SalesforceCallFailed: 'SalesforceCallFailed',
  SalesforceAuthenticationFailed: 'SalesforceAuthenticationFailed',
  SalesforceTokenRequestFailed: 'SalesforceTokenRequestFailed',
  SalesforceInvalidClientCredentials: 'SalesforceInvalidClientCredentials',
  SalesforceInstanceUrlInvalid: 'SalesforceInstanceUrlInvalid',
  SalesforceRateLimitExceeded: 'SalesforceRateLimitExceeded',
  SalesforceBulkApiUnavailable: 'SalesforceBulkApiUnavailable',
  SalesforceBulkJobFailed: 'SalesforceBulkJobFailed',
  SalesforceBulkJobTimedOut: 'SalesforceBulkJobTimedOut',
  SalesforceEntityNotFound: 'SalesforceEntityNotFound',
  SalesforceApiScopeNotGranted: 'SalesforceApiScopeNotGranted',
  SalesforceClientCredentialsNotConfigured: 'SalesforceClientCredentialsNotConfigured',
  SalesforceClientIdNotRecognized: 'SalesforceClientIdNotRecognized',
  LockAcquisitionFailed: 'LockAcquisitionFailed',
  AzureSqlAuthenticationFailed: 'AzureSqlAuthenticationFailed',
  AzureSqlConnectionTimeout: 'AzureSqlConnectionTimeout',
  AzureSqlPermissionDenied: 'AzureSqlPermissionDenied',
  AzureSqlSchemaMigrationFailed: 'AzureSqlSchemaMigrationFailed',
  AzureSqlDataImportFailed: 'AzureSqlDataImportFailed',
  AzureSqlMergeFailed: 'AzureSqlMergeFailed',
  AzureSqlConstraintViolation: 'AzureSqlConstraintViolation',
  AzureSqlDeadlock: 'AzureSqlDeadlock',
  AzureSqlDatabaseNotFound: 'AzureSqlDatabaseNotFound',
  AzureSqlServerNotFound: 'AzureSqlServerNotFound',
  AzureSqlTransactionTimeout: 'AzureSqlTransactionTimeout',
  AzureSqlInsufficientResources: 'AzureSqlInsufficientResources',
  AzureSqlSchemaMetadataNotFound: 'AzureSqlSchemaMetadataNotFound',
  AzureSqlPrimaryKeyStructureChanged: 'AzureSqlPrimaryKeyStructureChanged',
  AzureSqlUnsafeSchemaChange: 'AzureSqlUnsafeSchemaChange',
  AzureSqlMergeTimeout: 'AzureSqlMergeTimeout',
  AzureSqlFirewallBlocked: 'AzureSqlFirewallBlocked',
  AzureSqlSchemaNotFound: 'AzureSqlSchemaNotFound',
  AgentTaskTimedOut: 'AgentTaskTimedOut',
  AgentTaskFailed: 'AgentTaskFailed',
  UnsupportedTaskType: 'UnsupportedTaskType',
  AgentTaskNotPickedUp: 'AgentTaskNotPickedUp',
  SupportServiceUnavailable: 'SupportServiceUnavailable',
  SupportServiceMisconfigured: 'SupportServiceMisconfigured',
} as const;

export interface AgentTaskDto {
  taskId?: string;
  agentId?: string;
  orgId?: string;
  profileId?: string;
  targetId?: string;
  runId?: string;
  commandType?: string;
  status?: string;
  attemptCount?: number;
  createdUtc?: string;
  /** @nullable */
  startedUtc?: string | null;
  /** @nullable */
  completedUtc?: string | null;
  /** @nullable */
  errorCode?: AgentTaskDtoErrorCode;
  errorMessage?: string;
  regionId?: string;
}

export interface AllRunsPaginatedResult {
  items?: RunMetadataDto[];
  continuationToken?: string;
  hasMore?: boolean;
  totalItemsInPage?: number;
}

export interface AllSourceTableDto {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  logicalName: string;
  /** @minLength 1 */
  profileId: string;
  /** @minLength 1 */
  profileName: string;
  /** @minLength 1 */
  sourceId: string;
  isEnabled: boolean;
}

export interface AllSourceTablesResult {
  items?: AllSourceTableDto[];
  totalCount?: number;
}

export type AvailableSourceTableDto =
  | AvailableDataverseSourceTableDto
  | AvailableBusinessCentralSourceTableDto
  | AvailableSalesforceSourceTableDto;

export interface BcCompanyDto {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  name: string;
}

export interface CompleteTaskRequest {
  /** @nullable */
  rowsAffected?: number | null;
  /** @nullable */
  dataTransferredBytes?: number | null;
  outputJson?: string;
}

export type ConnectionTestResponseDetails = { [key: string]: string };

export interface ConnectionTestResponse {
  success?: boolean;
  message?: string;
  /** @nullable */
  errorCode?: number | null;
  details?: ConnectionTestResponseDetails;
}

export interface ContinuationToken {
  lastId?: string;
  lastCreatedUtc?: string;
}

export interface CreateAgentRequest {
  name?: string;
}

export interface CreateAgentResponse {
  agentId?: string;
  registrationToken?: string;
  tokenExpiresAtUtc?: string;
}

/**
 * @nullable
 */
export type CreateProfileRequestDeleteMode =
  | (typeof CreateProfileRequestDeleteMode)[keyof typeof CreateProfileRequestDeleteMode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateProfileRequestDeleteMode = {
  Soft: 'Soft',
  HardTombstone: 'HardTombstone',
  HardInventory: 'HardInventory',
} as const;

export interface CreateProfileRequest {
  name?: string;
  regionId?: string;
  isEnabled?: boolean;
  /** @nullable */
  deleteMode?: CreateProfileRequestDeleteMode;
}

export interface CreateProfileResponse {
  profileId?: string;
}

export interface CreateScheduleRequest {
  config?: ScheduleConfigRequest;
}

export interface CreateScheduleResponse {
  scheduleId?: string;
}

/**
 * @nullable
 */
export type ErrorProblemDetailsErrorCode =
  | (typeof ErrorProblemDetailsErrorCode)[keyof typeof ErrorProblemDetailsErrorCode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorProblemDetailsErrorCode = {
  Success: 'Success',
  BadRequest: 'BadRequest',
  Unauthorized: 'Unauthorized',
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  Conflict: 'Conflict',
  Gone: 'Gone',
  PayloadTooLarge: 'PayloadTooLarge',
  UnsupportedMediaType: 'UnsupportedMediaType',
  InternalServerError: 'InternalServerError',
  DatabaseError: 'DatabaseError',
  ServiceUnavailable: 'ServiceUnavailable',
  DataExtractionFailed: 'DataExtractionFailed',
  SchemaExtractionFailed: 'SchemaExtractionFailed',
  CheckpointRetrievalFailed: 'CheckpointRetrievalFailed',
  TargetLoadFailed: 'TargetLoadFailed',
  DataTransformationFailed: 'DataTransformationFailed',
  SourceConnectionFailed: 'SourceConnectionFailed',
  TargetConnectionFailed: 'TargetConnectionFailed',
  RateLimitExceeded: 'RateLimitExceeded',
  TimeoutError: 'TimeoutError',
  NetworkError: 'NetworkError',
  OrchestrationTimeout: 'OrchestrationTimeout',
  OrchestrationCancelled: 'OrchestrationCancelled',
  OrchestrationOrphaned: 'OrchestrationOrphaned',
  InvalidConfiguration: 'InvalidConfiguration',
  TargetInitialSyncConflict: 'TargetInitialSyncConflict',
  DataverseCallFailed: 'DataverseCallFailed',
  DataverseAuthenticationFailed: 'DataverseAuthenticationFailed',
  DataverseChangeTrackingNotEnabled: 'DataverseChangeTrackingNotEnabled',
  DataverseEntityNotFound: 'DataverseEntityNotFound',
  DataversePermissionDenied: 'DataversePermissionDenied',
  DataverseInvalidEntityConfiguration: 'DataverseInvalidEntityConfiguration',
  DataverseSecretRetrievalFailed: 'DataverseSecretRetrievalFailed',
  DataverseHostnameNotFound: 'DataverseHostnameNotFound',
  DataverseInvalidUrl: 'DataverseInvalidUrl',
  DataverseInvalidClientId: 'DataverseInvalidClientId',
  DataverseInvalidClientSecret: 'DataverseInvalidClientSecret',
  DataverseInvalidAppRegistration: 'DataverseInvalidAppRegistration',
  DataverseInvalidTenant: 'DataverseInvalidTenant',
  DataverseConnectionFailed: 'DataverseConnectionFailed',
  DataversePermissionDeniedMetadata: 'DataversePermissionDeniedMetadata',
  DataversePermissionDeniedData: 'DataversePermissionDeniedData',
  DataverseVersionStampExpired: 'DataverseVersionStampExpired',
  DataverseInvalidRequest: 'DataverseInvalidRequest',
  BcCallFailed: 'BcCallFailed',
  BcAuthenticationFailed: 'BcAuthenticationFailed',
  BcInvalidClientId: 'BcInvalidClientId',
  BcInvalidClientSecret: 'BcInvalidClientSecret',
  BcEnvironmentNotFound: 'BcEnvironmentNotFound',
  BcPermissionDenied: 'BcPermissionDenied',
  BcEntityNotFound: 'BcEntityNotFound',
  BcInvalidRequest: 'BcInvalidRequest',
  BcTenantUnavailable: 'BcTenantUnavailable',
  BcCompanyNotFound: 'BcCompanyNotFound',
  BcNotFound: 'BcNotFound',
  BcEntityNotSupported: 'BcEntityNotSupported',
  SalesforceCallFailed: 'SalesforceCallFailed',
  SalesforceAuthenticationFailed: 'SalesforceAuthenticationFailed',
  SalesforceTokenRequestFailed: 'SalesforceTokenRequestFailed',
  SalesforceInvalidClientCredentials: 'SalesforceInvalidClientCredentials',
  SalesforceInstanceUrlInvalid: 'SalesforceInstanceUrlInvalid',
  SalesforceRateLimitExceeded: 'SalesforceRateLimitExceeded',
  SalesforceBulkApiUnavailable: 'SalesforceBulkApiUnavailable',
  SalesforceBulkJobFailed: 'SalesforceBulkJobFailed',
  SalesforceBulkJobTimedOut: 'SalesforceBulkJobTimedOut',
  SalesforceEntityNotFound: 'SalesforceEntityNotFound',
  SalesforceApiScopeNotGranted: 'SalesforceApiScopeNotGranted',
  SalesforceClientCredentialsNotConfigured: 'SalesforceClientCredentialsNotConfigured',
  SalesforceClientIdNotRecognized: 'SalesforceClientIdNotRecognized',
  LockAcquisitionFailed: 'LockAcquisitionFailed',
  AzureSqlAuthenticationFailed: 'AzureSqlAuthenticationFailed',
  AzureSqlConnectionTimeout: 'AzureSqlConnectionTimeout',
  AzureSqlPermissionDenied: 'AzureSqlPermissionDenied',
  AzureSqlSchemaMigrationFailed: 'AzureSqlSchemaMigrationFailed',
  AzureSqlDataImportFailed: 'AzureSqlDataImportFailed',
  AzureSqlMergeFailed: 'AzureSqlMergeFailed',
  AzureSqlConstraintViolation: 'AzureSqlConstraintViolation',
  AzureSqlDeadlock: 'AzureSqlDeadlock',
  AzureSqlDatabaseNotFound: 'AzureSqlDatabaseNotFound',
  AzureSqlServerNotFound: 'AzureSqlServerNotFound',
  AzureSqlTransactionTimeout: 'AzureSqlTransactionTimeout',
  AzureSqlInsufficientResources: 'AzureSqlInsufficientResources',
  AzureSqlSchemaMetadataNotFound: 'AzureSqlSchemaMetadataNotFound',
  AzureSqlPrimaryKeyStructureChanged: 'AzureSqlPrimaryKeyStructureChanged',
  AzureSqlUnsafeSchemaChange: 'AzureSqlUnsafeSchemaChange',
  AzureSqlMergeTimeout: 'AzureSqlMergeTimeout',
  AzureSqlFirewallBlocked: 'AzureSqlFirewallBlocked',
  AzureSqlSchemaNotFound: 'AzureSqlSchemaNotFound',
  AgentTaskTimedOut: 'AgentTaskTimedOut',
  AgentTaskFailed: 'AgentTaskFailed',
  UnsupportedTaskType: 'UnsupportedTaskType',
  AgentTaskNotPickedUp: 'AgentTaskNotPickedUp',
  SupportServiceUnavailable: 'SupportServiceUnavailable',
  SupportServiceMisconfigured: 'SupportServiceMisconfigured',
} as const;

export interface ErrorProblemDetails {
  /** @nullable */
  errorCode?: ErrorProblemDetailsErrorCode;
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
}

export interface FailedMigrationColumnDto {
  col?: string;
  from?: string;
  to?: string;
}

/**
 * @nullable
 */
export type FailTaskRequestErrorCode =
  | (typeof FailTaskRequestErrorCode)[keyof typeof FailTaskRequestErrorCode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FailTaskRequestErrorCode = {
  Success: 'Success',
  BadRequest: 'BadRequest',
  Unauthorized: 'Unauthorized',
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  Conflict: 'Conflict',
  Gone: 'Gone',
  PayloadTooLarge: 'PayloadTooLarge',
  UnsupportedMediaType: 'UnsupportedMediaType',
  InternalServerError: 'InternalServerError',
  DatabaseError: 'DatabaseError',
  ServiceUnavailable: 'ServiceUnavailable',
  DataExtractionFailed: 'DataExtractionFailed',
  SchemaExtractionFailed: 'SchemaExtractionFailed',
  CheckpointRetrievalFailed: 'CheckpointRetrievalFailed',
  TargetLoadFailed: 'TargetLoadFailed',
  DataTransformationFailed: 'DataTransformationFailed',
  SourceConnectionFailed: 'SourceConnectionFailed',
  TargetConnectionFailed: 'TargetConnectionFailed',
  RateLimitExceeded: 'RateLimitExceeded',
  TimeoutError: 'TimeoutError',
  NetworkError: 'NetworkError',
  OrchestrationTimeout: 'OrchestrationTimeout',
  OrchestrationCancelled: 'OrchestrationCancelled',
  OrchestrationOrphaned: 'OrchestrationOrphaned',
  InvalidConfiguration: 'InvalidConfiguration',
  TargetInitialSyncConflict: 'TargetInitialSyncConflict',
  DataverseCallFailed: 'DataverseCallFailed',
  DataverseAuthenticationFailed: 'DataverseAuthenticationFailed',
  DataverseChangeTrackingNotEnabled: 'DataverseChangeTrackingNotEnabled',
  DataverseEntityNotFound: 'DataverseEntityNotFound',
  DataversePermissionDenied: 'DataversePermissionDenied',
  DataverseInvalidEntityConfiguration: 'DataverseInvalidEntityConfiguration',
  DataverseSecretRetrievalFailed: 'DataverseSecretRetrievalFailed',
  DataverseHostnameNotFound: 'DataverseHostnameNotFound',
  DataverseInvalidUrl: 'DataverseInvalidUrl',
  DataverseInvalidClientId: 'DataverseInvalidClientId',
  DataverseInvalidClientSecret: 'DataverseInvalidClientSecret',
  DataverseInvalidAppRegistration: 'DataverseInvalidAppRegistration',
  DataverseInvalidTenant: 'DataverseInvalidTenant',
  DataverseConnectionFailed: 'DataverseConnectionFailed',
  DataversePermissionDeniedMetadata: 'DataversePermissionDeniedMetadata',
  DataversePermissionDeniedData: 'DataversePermissionDeniedData',
  DataverseVersionStampExpired: 'DataverseVersionStampExpired',
  DataverseInvalidRequest: 'DataverseInvalidRequest',
  BcCallFailed: 'BcCallFailed',
  BcAuthenticationFailed: 'BcAuthenticationFailed',
  BcInvalidClientId: 'BcInvalidClientId',
  BcInvalidClientSecret: 'BcInvalidClientSecret',
  BcEnvironmentNotFound: 'BcEnvironmentNotFound',
  BcPermissionDenied: 'BcPermissionDenied',
  BcEntityNotFound: 'BcEntityNotFound',
  BcInvalidRequest: 'BcInvalidRequest',
  BcTenantUnavailable: 'BcTenantUnavailable',
  BcCompanyNotFound: 'BcCompanyNotFound',
  BcNotFound: 'BcNotFound',
  BcEntityNotSupported: 'BcEntityNotSupported',
  SalesforceCallFailed: 'SalesforceCallFailed',
  SalesforceAuthenticationFailed: 'SalesforceAuthenticationFailed',
  SalesforceTokenRequestFailed: 'SalesforceTokenRequestFailed',
  SalesforceInvalidClientCredentials: 'SalesforceInvalidClientCredentials',
  SalesforceInstanceUrlInvalid: 'SalesforceInstanceUrlInvalid',
  SalesforceRateLimitExceeded: 'SalesforceRateLimitExceeded',
  SalesforceBulkApiUnavailable: 'SalesforceBulkApiUnavailable',
  SalesforceBulkJobFailed: 'SalesforceBulkJobFailed',
  SalesforceBulkJobTimedOut: 'SalesforceBulkJobTimedOut',
  SalesforceEntityNotFound: 'SalesforceEntityNotFound',
  SalesforceApiScopeNotGranted: 'SalesforceApiScopeNotGranted',
  SalesforceClientCredentialsNotConfigured: 'SalesforceClientCredentialsNotConfigured',
  SalesforceClientIdNotRecognized: 'SalesforceClientIdNotRecognized',
  LockAcquisitionFailed: 'LockAcquisitionFailed',
  AzureSqlAuthenticationFailed: 'AzureSqlAuthenticationFailed',
  AzureSqlConnectionTimeout: 'AzureSqlConnectionTimeout',
  AzureSqlPermissionDenied: 'AzureSqlPermissionDenied',
  AzureSqlSchemaMigrationFailed: 'AzureSqlSchemaMigrationFailed',
  AzureSqlDataImportFailed: 'AzureSqlDataImportFailed',
  AzureSqlMergeFailed: 'AzureSqlMergeFailed',
  AzureSqlConstraintViolation: 'AzureSqlConstraintViolation',
  AzureSqlDeadlock: 'AzureSqlDeadlock',
  AzureSqlDatabaseNotFound: 'AzureSqlDatabaseNotFound',
  AzureSqlServerNotFound: 'AzureSqlServerNotFound',
  AzureSqlTransactionTimeout: 'AzureSqlTransactionTimeout',
  AzureSqlInsufficientResources: 'AzureSqlInsufficientResources',
  AzureSqlSchemaMetadataNotFound: 'AzureSqlSchemaMetadataNotFound',
  AzureSqlPrimaryKeyStructureChanged: 'AzureSqlPrimaryKeyStructureChanged',
  AzureSqlUnsafeSchemaChange: 'AzureSqlUnsafeSchemaChange',
  AzureSqlMergeTimeout: 'AzureSqlMergeTimeout',
  AzureSqlFirewallBlocked: 'AzureSqlFirewallBlocked',
  AzureSqlSchemaNotFound: 'AzureSqlSchemaNotFound',
  AgentTaskTimedOut: 'AgentTaskTimedOut',
  AgentTaskFailed: 'AgentTaskFailed',
  UnsupportedTaskType: 'UnsupportedTaskType',
  AgentTaskNotPickedUp: 'AgentTaskNotPickedUp',
  SupportServiceUnavailable: 'SupportServiceUnavailable',
  SupportServiceMisconfigured: 'SupportServiceMisconfigured',
} as const;

export interface FailTaskRequest {
  /** @nullable */
  errorCode?: FailTaskRequestErrorCode;
  errorMessage?: string;
}

export type GetAllRunsRequestStatesItem =
  (typeof GetAllRunsRequestStatesItem)[keyof typeof GetAllRunsRequestStatesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAllRunsRequestStatesItem = {
  Scheduled: 'Scheduled',
  Extracting: 'Extracting',
  WaitingForTargetLease: 'WaitingForTargetLease',
  WaitingForSourceCapacity: 'WaitingForSourceCapacity',
  Loading: 'Loading',
  Completed: 'Completed',
  Failed: 'Failed',
  Cancelling: 'Cancelling',
  Cancelled: 'Cancelled',
  Skipped: 'Skipped',
} as const;

export interface GetAllRunsRequest {
  pageSize?: number;
  continuationToken?: string;
  states?: GetAllRunsRequestStatesItem[];
  /** @nullable */
  startDate?: string | null;
  /** @nullable */
  endDate?: string | null;
  profileIds?: string[];
  sourceTableLogicalNames?: string[];
  sourceTableIds?: string[];
}

export interface GetAllSourceTablesRequest {
  profileIds?: string[];
  /** @nullable */
  onlyEnabled?: boolean | null;
}

export interface GetRunMetadataRequest {
  pageSize?: number;
  continuationToken?: string;
}

export interface HeartbeatRequest {
  version?: Version;
  logs?: AgentLogEntryRequest[];
}

export interface HeartbeatResponse {
  sessionLease: SessionLeaseResponse;
  heartbeatIntervalSeconds?: number;
  workerCount?: number;
}

export type ITaskPayload = ExecuteSqlPayload | SqlBulkLoadPagePayload;

export interface ListProfilesRequest {
  pageSize?: number;
  continuationToken?: ContinuationToken;
}

export interface ListSourceTablesRequest {
  pageSize?: number;
  continuationToken?: ContinuationToken;
  search?: string;
}

export interface OrgSettingsDto {
  /** @minLength 1 */
  orgId: string;
  defaultRegion?: string;
  /** @minLength 1 */
  createdUtc: string;
  /** @nullable */
  updatedUtc?: string | null;
  /** Maximum concurrent Dataverse requests per environment and app registration; 0 means no limit. */
  dataverseMaxConcurrentRequests?: number;
}

export interface PaginatedResultProfileDto {
  items?: ProfileDto[];
  continuationToken?: ContinuationToken;
  hasMore?: boolean;
}

export interface PaginatedResultSourceTableDto {
  items?: SourceTableDto[];
  continuationToken?: ContinuationToken;
  hasMore?: boolean;
}

export type ProfileDtoDeleteMode = (typeof ProfileDtoDeleteMode)[keyof typeof ProfileDtoDeleteMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProfileDtoDeleteMode = {
  Soft: 'Soft',
  HardTombstone: 'HardTombstone',
  HardInventory: 'HardInventory',
} as const;

export interface ProfileDto {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  orgId: string;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  regionId: string;
  isEnabled: boolean;
  deleteMode: ProfileDtoDeleteMode;
  /** @minLength 1 */
  createdUtc: string;
  hasTriggeredInitialSync: boolean;
}

export type ProfileWithSourceAndTargetDtoDeleteMode =
  (typeof ProfileWithSourceAndTargetDtoDeleteMode)[keyof typeof ProfileWithSourceAndTargetDtoDeleteMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProfileWithSourceAndTargetDtoDeleteMode = {
  Soft: 'Soft',
  HardTombstone: 'HardTombstone',
  HardInventory: 'HardInventory',
} as const;

export interface ProfileWithSourceAndTargetDto {
  source?: SourceDto;
  target?: TargetDto;
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  orgId: string;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  regionId: string;
  isEnabled: boolean;
  deleteMode: ProfileWithSourceAndTargetDtoDeleteMode;
  /** @minLength 1 */
  createdUtc: string;
  hasTriggeredInitialSync: boolean;
}

export interface RegenerateTokenResponse {
  registrationToken?: string;
  tokenExpiresAtUtc?: string;
}

export interface RegisterAgentRequest {
  registrationToken?: string;
}

export interface RegisterAgentResponse {
  agentId?: string;
  organizationId?: string;
  token?: string;
}

export type RunMetadataDtoSyncMode =
  (typeof RunMetadataDtoSyncMode)[keyof typeof RunMetadataDtoSyncMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunMetadataDtoSyncMode = {
  Incremental: 'Incremental',
  Full: 'Full',
  ResetAndFull: 'ResetAndFull',
  Inventory: 'Inventory',
} as const;

export type RunMetadataDtoState = (typeof RunMetadataDtoState)[keyof typeof RunMetadataDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunMetadataDtoState = {
  Scheduled: 'Scheduled',
  Extracting: 'Extracting',
  WaitingForTargetLease: 'WaitingForTargetLease',
  WaitingForSourceCapacity: 'WaitingForSourceCapacity',
  Loading: 'Loading',
  Completed: 'Completed',
  Failed: 'Failed',
  Cancelling: 'Cancelling',
  Cancelled: 'Cancelled',
  Skipped: 'Skipped',
} as const;

/**
 * @nullable
 */
export type RunMetadataDtoErrorCode =
  | (typeof RunMetadataDtoErrorCode)[keyof typeof RunMetadataDtoErrorCode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunMetadataDtoErrorCode = {
  Success: 'Success',
  BadRequest: 'BadRequest',
  Unauthorized: 'Unauthorized',
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  Conflict: 'Conflict',
  Gone: 'Gone',
  PayloadTooLarge: 'PayloadTooLarge',
  UnsupportedMediaType: 'UnsupportedMediaType',
  InternalServerError: 'InternalServerError',
  DatabaseError: 'DatabaseError',
  ServiceUnavailable: 'ServiceUnavailable',
  DataExtractionFailed: 'DataExtractionFailed',
  SchemaExtractionFailed: 'SchemaExtractionFailed',
  CheckpointRetrievalFailed: 'CheckpointRetrievalFailed',
  TargetLoadFailed: 'TargetLoadFailed',
  DataTransformationFailed: 'DataTransformationFailed',
  SourceConnectionFailed: 'SourceConnectionFailed',
  TargetConnectionFailed: 'TargetConnectionFailed',
  RateLimitExceeded: 'RateLimitExceeded',
  TimeoutError: 'TimeoutError',
  NetworkError: 'NetworkError',
  OrchestrationTimeout: 'OrchestrationTimeout',
  OrchestrationCancelled: 'OrchestrationCancelled',
  OrchestrationOrphaned: 'OrchestrationOrphaned',
  InvalidConfiguration: 'InvalidConfiguration',
  TargetInitialSyncConflict: 'TargetInitialSyncConflict',
  DataverseCallFailed: 'DataverseCallFailed',
  DataverseAuthenticationFailed: 'DataverseAuthenticationFailed',
  DataverseChangeTrackingNotEnabled: 'DataverseChangeTrackingNotEnabled',
  DataverseEntityNotFound: 'DataverseEntityNotFound',
  DataversePermissionDenied: 'DataversePermissionDenied',
  DataverseInvalidEntityConfiguration: 'DataverseInvalidEntityConfiguration',
  DataverseSecretRetrievalFailed: 'DataverseSecretRetrievalFailed',
  DataverseHostnameNotFound: 'DataverseHostnameNotFound',
  DataverseInvalidUrl: 'DataverseInvalidUrl',
  DataverseInvalidClientId: 'DataverseInvalidClientId',
  DataverseInvalidClientSecret: 'DataverseInvalidClientSecret',
  DataverseInvalidAppRegistration: 'DataverseInvalidAppRegistration',
  DataverseInvalidTenant: 'DataverseInvalidTenant',
  DataverseConnectionFailed: 'DataverseConnectionFailed',
  DataversePermissionDeniedMetadata: 'DataversePermissionDeniedMetadata',
  DataversePermissionDeniedData: 'DataversePermissionDeniedData',
  DataverseVersionStampExpired: 'DataverseVersionStampExpired',
  DataverseInvalidRequest: 'DataverseInvalidRequest',
  BcCallFailed: 'BcCallFailed',
  BcAuthenticationFailed: 'BcAuthenticationFailed',
  BcInvalidClientId: 'BcInvalidClientId',
  BcInvalidClientSecret: 'BcInvalidClientSecret',
  BcEnvironmentNotFound: 'BcEnvironmentNotFound',
  BcPermissionDenied: 'BcPermissionDenied',
  BcEntityNotFound: 'BcEntityNotFound',
  BcInvalidRequest: 'BcInvalidRequest',
  BcTenantUnavailable: 'BcTenantUnavailable',
  BcCompanyNotFound: 'BcCompanyNotFound',
  BcNotFound: 'BcNotFound',
  BcEntityNotSupported: 'BcEntityNotSupported',
  SalesforceCallFailed: 'SalesforceCallFailed',
  SalesforceAuthenticationFailed: 'SalesforceAuthenticationFailed',
  SalesforceTokenRequestFailed: 'SalesforceTokenRequestFailed',
  SalesforceInvalidClientCredentials: 'SalesforceInvalidClientCredentials',
  SalesforceInstanceUrlInvalid: 'SalesforceInstanceUrlInvalid',
  SalesforceRateLimitExceeded: 'SalesforceRateLimitExceeded',
  SalesforceBulkApiUnavailable: 'SalesforceBulkApiUnavailable',
  SalesforceBulkJobFailed: 'SalesforceBulkJobFailed',
  SalesforceBulkJobTimedOut: 'SalesforceBulkJobTimedOut',
  SalesforceEntityNotFound: 'SalesforceEntityNotFound',
  SalesforceApiScopeNotGranted: 'SalesforceApiScopeNotGranted',
  SalesforceClientCredentialsNotConfigured: 'SalesforceClientCredentialsNotConfigured',
  SalesforceClientIdNotRecognized: 'SalesforceClientIdNotRecognized',
  LockAcquisitionFailed: 'LockAcquisitionFailed',
  AzureSqlAuthenticationFailed: 'AzureSqlAuthenticationFailed',
  AzureSqlConnectionTimeout: 'AzureSqlConnectionTimeout',
  AzureSqlPermissionDenied: 'AzureSqlPermissionDenied',
  AzureSqlSchemaMigrationFailed: 'AzureSqlSchemaMigrationFailed',
  AzureSqlDataImportFailed: 'AzureSqlDataImportFailed',
  AzureSqlMergeFailed: 'AzureSqlMergeFailed',
  AzureSqlConstraintViolation: 'AzureSqlConstraintViolation',
  AzureSqlDeadlock: 'AzureSqlDeadlock',
  AzureSqlDatabaseNotFound: 'AzureSqlDatabaseNotFound',
  AzureSqlServerNotFound: 'AzureSqlServerNotFound',
  AzureSqlTransactionTimeout: 'AzureSqlTransactionTimeout',
  AzureSqlInsufficientResources: 'AzureSqlInsufficientResources',
  AzureSqlSchemaMetadataNotFound: 'AzureSqlSchemaMetadataNotFound',
  AzureSqlPrimaryKeyStructureChanged: 'AzureSqlPrimaryKeyStructureChanged',
  AzureSqlUnsafeSchemaChange: 'AzureSqlUnsafeSchemaChange',
  AzureSqlMergeTimeout: 'AzureSqlMergeTimeout',
  AzureSqlFirewallBlocked: 'AzureSqlFirewallBlocked',
  AzureSqlSchemaNotFound: 'AzureSqlSchemaNotFound',
  AgentTaskTimedOut: 'AgentTaskTimedOut',
  AgentTaskFailed: 'AgentTaskFailed',
  UnsupportedTaskType: 'UnsupportedTaskType',
  AgentTaskNotPickedUp: 'AgentTaskNotPickedUp',
  SupportServiceUnavailable: 'SupportServiceUnavailable',
  SupportServiceMisconfigured: 'SupportServiceMisconfigured',
} as const;

/**
 * @nullable
 */
export type RunMetadataDtoErrorRunState =
  | (typeof RunMetadataDtoErrorRunState)[keyof typeof RunMetadataDtoErrorRunState]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunMetadataDtoErrorRunState = {
  Scheduled: 'Scheduled',
  Extracting: 'Extracting',
  WaitingForTargetLease: 'WaitingForTargetLease',
  WaitingForSourceCapacity: 'WaitingForSourceCapacity',
  Loading: 'Loading',
  Completed: 'Completed',
  Failed: 'Failed',
  Cancelling: 'Cancelling',
  Cancelled: 'Cancelled',
  Skipped: 'Skipped',
} as const;

/**
 * @nullable
 */
export type RunMetadataDtoDeleteMode =
  | (typeof RunMetadataDtoDeleteMode)[keyof typeof RunMetadataDtoDeleteMode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunMetadataDtoDeleteMode = {
  Soft: 'Soft',
  HardTombstone: 'HardTombstone',
  HardInventory: 'HardInventory',
} as const;

/**
 * @nullable
 */
export type RunMetadataDtoSkipReason =
  | (typeof RunMetadataDtoSkipReason)[keyof typeof RunMetadataDtoSkipReason]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunMetadataDtoSkipReason = {
  NoChangesDetected: 'NoChangesDetected',
  InsufficientEntitlements: 'InsufficientEntitlements',
  ObsoleteCheckpoint: 'ObsoleteCheckpoint',
  InitialSyncAlreadyCompleted: 'InitialSyncAlreadyCompleted',
  EntityNotAvailable: 'EntityNotAvailable',
} as const;

/**
 * @nullable
 */
export type RunMetadataDtoTriggerSource =
  | (typeof RunMetadataDtoTriggerSource)[keyof typeof RunMetadataDtoTriggerSource]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RunMetadataDtoTriggerSource = {
  Manual: 'Manual',
  Scheduled: 'Scheduled',
} as const;

export interface RunMetadataDto {
  /** @minLength 1 */
  profileId: string;
  /** @minLength 1 */
  sourceId: string;
  /** @minLength 1 */
  sourceTableId: string;
  /** @minLength 1 */
  sourceTableLogicalName: string;
  /** @minLength 1 */
  targetId: string;
  /** @minLength 1 */
  runId: string;
  syncMode: RunMetadataDtoSyncMode;
  state: RunMetadataDtoState;
  /** @nullable */
  scheduledUtc?: string | null;
  /** @nullable */
  startedUtc?: string | null;
  /** @nullable */
  completedUtc?: string | null;
  /** @nullable */
  extractionStartedUtc?: string | null;
  /** @nullable */
  extractionCompletedUtc?: string | null;
  /** @nullable */
  rowsExtracted?: number | null;
  /** @nullable */
  bytesExtracted?: number | null;
  /** @nullable */
  loadStartedUtc?: string | null;
  /** @nullable */
  loadCompletedUtc?: string | null;
  /** @nullable */
  rowsLoaded?: number | null;
  /** @nullable */
  rowsInserted?: number | null;
  /** @nullable */
  rowsUpdated?: number | null;
  /** @nullable */
  rowsDeleted?: number | null;
  /** @nullable */
  errorCode?: RunMetadataDtoErrorCode;
  errorMessage?: string;
  /** @nullable */
  errorRunState?: RunMetadataDtoErrorRunState;
  externalErrorCode?: string;
  externalErrorMessage?: string;
  region?: string;
  /** @nullable */
  deleteMode?: RunMetadataDtoDeleteMode;
  /** @nullable */
  skipReason?: RunMetadataDtoSkipReason;
  /** @nullable */
  triggerSource?: RunMetadataDtoTriggerSource;
  schemaChanges?: SchemaChangeSummaryDto;
}

export interface RunMetadataPaginatedResult {
  items?: RunMetadataDto[];
  continuationToken?: string;
  hasMore?: boolean;
}

export type ScheduleConfigRequest =
  | QuietTimeDailyScheduleConfigRequest
  | QuietTimeWeeklyScheduleConfigRequest;

export type ScheduleDto = QuietTimeDailyScheduleDto | QuietTimeWeeklyScheduleDto;

export interface SchemaChangeSummaryDto {
  columnsCreated?: SchemaCreatedColumnDto[];
  columnsWidened?: SchemaWidenedColumnDto[];
  failedMigrations?: FailedMigrationColumnDto[];
}

export interface SchemaCreatedColumnDto {
  entity?: string;
  columnName?: string;
  sqlType?: string;
  isNullable?: boolean;
  isPrimaryKey?: boolean;
}

export interface TargetSchemaColumnDto {
  column?: string;
  sqlType?: string;
  isNullable?: boolean;
  isPrimaryKey?: boolean;
}

export interface TargetSchemaTableDto {
  targetTableName?: string;
  columns?: TargetSchemaColumnDto[];
}

export interface TargetSchemaResponse {
  tables?: TargetSchemaTableDto[];
}

export interface SchemaWidenedColumnDto {
  entity?: string;
  columnName?: string;
  fromType?: string;
  toType?: string;
}

export interface SessionLeaseResponse {
  serviceBusNamespace?: string;
  queueName?: string;
  sasToken?: string;
  expiresAtUtc?: string;
}

export type SourceConfigRequest =
  | DataverseSourceConfigRequest
  | BusinessCentralSourceConfigRequest
  | SalesforceSourceConfigRequest;

export type SourceDto = DataverseSourceDto | BusinessCentralSourceDto | SalesforceSourceDto;

export type SourceTableDto =
  | DataverseSourceTableDto
  | BusinessCentralSourceTableDto
  | SalesforceSourceTableDto;

export interface StartTaskResponse {
  taskId?: string;
  payload: ITaskPayload;
}

export interface SuccessResponse {
  message?: string;
}

/**
 * @nullable
 */
export type SyncRequestSyncMode =
  | (typeof SyncRequestSyncMode)[keyof typeof SyncRequestSyncMode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SyncRequestSyncMode = {
  Incremental: 'Incremental',
  Full: 'Full',
  ResetAndFull: 'ResetAndFull',
  Inventory: 'Inventory',
} as const;

export interface SyncRequest {
  /** @nullable */
  syncMode?: SyncRequestSyncMode;
}

export type TargetConfigRequest = AzureSqlTargetConfigAadAppRequest | AzureSqlConfigBasicRequest;

export type TargetDto = AzureSqlTargetDto | AzureSqlCredentialTargetDto;

export type TestAzureSqlConnectionRequest =
  | TestAzureSqlConnectionAadAppRequest
  | TestAzureSqlConnectionBasicRequest;

export interface TestBcConnectionRequest {
  tenantId?: string;
  environment?: string;
  clientId?: string;
  clientSecret?: string;
}

export interface TestBcConnectionResponse {
  success: boolean;
  /** @minLength 1 */
  message: string;
  companies: BcCompanyDto[];
}

export interface TestDataverseConnectionRequest {
  baseUrl?: string;
  clientId?: string;
  clientSecret?: string;
}

export interface TestSalesforceConnectionRequest {
  instanceUrl?: string;
  clientId?: string;
  clientSecret?: string;
  isSandbox?: boolean;
}

export interface UpdateAgentRequest {
  name?: string;
  status?: string;
  /** @nullable */
  workerCount?: number | null;
}

export interface UpdateOrgSettingsRequest {
  defaultRegion?: string;
}

/**
 * @nullable
 */
export type UpdateProfileRequestDeleteMode =
  | (typeof UpdateProfileRequestDeleteMode)[keyof typeof UpdateProfileRequestDeleteMode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateProfileRequestDeleteMode = {
  Soft: 'Soft',
  HardTombstone: 'HardTombstone',
  HardInventory: 'HardInventory',
} as const;

export interface UpdateProfileRequest {
  name?: string;
  regionId?: string;
  /** @nullable */
  isEnabled?: boolean | null;
  /** @nullable */
  deleteMode?: UpdateProfileRequestDeleteMode;
}

export interface UpdateSourceRequest {
  config?: SourceConfigRequest;
}

export interface UpdateSourceTableStateRequest {
  isEnabled?: boolean;
}

export type UpdateTargetConfigRequest =
  | UpdateAzureSqlTargetConfigAadAppRequest
  | UpdateAzureSqlConfigBasicRequest;

export interface UpdateTargetRequest {
  config?: UpdateTargetConfigRequest;
  /** @nullable */
  agentId?: string | null;
}

export interface Version {
  major?: number;
  minor?: number;
  build?: number;
  revision?: number;
  majorRevision?: number;
  minorRevision?: number;
}

export interface Void {
  [key: string]: unknown;
}

export type AddDataverseSourceTableRequestType =
  (typeof AddDataverseSourceTableRequestType)[keyof typeof AddDataverseSourceTableRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddDataverseSourceTableRequestType = {
  Dataverse: 'Dataverse',
} as const;

export interface AddDataverseSourceTableRequest {
  logicalName?: string;
  /** @nullable */
  displayName?: string | null;
  isEnabled?: boolean;
  $type: AddDataverseSourceTableRequestType;
}

export type AddBusinessCentralSourceTableRequestType =
  (typeof AddBusinessCentralSourceTableRequestType)[keyof typeof AddBusinessCentralSourceTableRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddBusinessCentralSourceTableRequestType = {
  BusinessCentral: 'BusinessCentral',
} as const;

export interface AddBusinessCentralSourceTableRequest {
  apiEndpoint?: BcApiEndpoint;
  /** @nullable */
  timestampField?: string | null;
  /** @nullable */
  hasIsDeletedField?: boolean | null;
  /** @nullable */
  isDeletedFieldName?: string | null;
  logicalName?: string;
  /** @nullable */
  displayName?: string | null;
  isEnabled?: boolean;
  $type: AddBusinessCentralSourceTableRequestType;
}

export type BcApiEndpoint = (typeof BcApiEndpoint)[keyof typeof BcApiEndpoint];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BcApiEndpoint = {
  V2: 'V2',
  ODataV4: 'ODataV4',
} as const;

export type AddSalesforceSourceTableRequestType =
  (typeof AddSalesforceSourceTableRequestType)[keyof typeof AddSalesforceSourceTableRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddSalesforceSourceTableRequestType = {
  Salesforce: 'Salesforce',
} as const;

export interface AddSalesforceSourceTableRequest {
  logicalName?: string;
  /** @nullable */
  displayName?: string | null;
  isEnabled?: boolean;
  $type: AddSalesforceSourceTableRequestType;
}

export type DataverseSourceConfigRequestType =
  (typeof DataverseSourceConfigRequestType)[keyof typeof DataverseSourceConfigRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataverseSourceConfigRequestType = {
  Dataverse: 'Dataverse',
} as const;

export interface DataverseSourceConfigRequest {
  baseUrl?: string;
  clientId?: string;
  clientSecret?: string;
  pageSize?: number;
  dataverseLookupLabelMaxLength?: number;
  dataverseChoiceLabelMaxLength?: number;
  dataverseMultiSelectMaxLength?: number;
  $type: DataverseSourceConfigRequestType;
}

export type BusinessCentralSourceConfigRequestType =
  (typeof BusinessCentralSourceConfigRequestType)[keyof typeof BusinessCentralSourceConfigRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessCentralSourceConfigRequestType = {
  BusinessCentral: 'BusinessCentral',
} as const;

export interface BusinessCentralSourceConfigRequest {
  tenantId?: string;
  environment?: string;
  clientId?: string;
  clientSecret?: string;
  companyId?: string;
  companyName?: string;
  pageSize?: number;
  $type: BusinessCentralSourceConfigRequestType;
}

export type SalesforceSourceConfigRequestType =
  (typeof SalesforceSourceConfigRequestType)[keyof typeof SalesforceSourceConfigRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SalesforceSourceConfigRequestType = {
  Salesforce: 'Salesforce',
} as const;

export interface SalesforceSourceConfigRequest {
  instanceUrl?: string;
  clientId?: string;
  clientSecret?: string;
  isSandbox?: boolean;
  pageSize?: number;
  $type: SalesforceSourceConfigRequestType;
}

export type AzureSqlTargetConfigAadAppRequestType =
  (typeof AzureSqlTargetConfigAadAppRequestType)[keyof typeof AzureSqlTargetConfigAadAppRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AzureSqlTargetConfigAadAppRequestType = {
  AadApp: 'AadApp',
} as const;

export interface AzureSqlTargetConfigAadAppRequest {
  tenantId: string;
  clientId: string;
  clientSecret: string;
  server: string;
  database: string;
  schemaName: string;
  /** @nullable */
  tablePrefix?: string | null;
  $type: AzureSqlTargetConfigAadAppRequestType;
}

export type AzureSqlConfigBasicRequestType =
  (typeof AzureSqlConfigBasicRequestType)[keyof typeof AzureSqlConfigBasicRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AzureSqlConfigBasicRequestType = {
  Basic: 'Basic',
} as const;

export interface AzureSqlConfigBasicRequest {
  username: string;
  password: string;
  encryptConnection?: boolean;
  server: string;
  database: string;
  schemaName: string;
  /** @nullable */
  tablePrefix?: string | null;
  $type: AzureSqlConfigBasicRequestType;
}

export type TestAzureSqlConnectionAadAppRequestType =
  (typeof TestAzureSqlConnectionAadAppRequestType)[keyof typeof TestAzureSqlConnectionAadAppRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestAzureSqlConnectionAadAppRequestType = {
  AadApp: 'AadApp',
} as const;

export interface TestAzureSqlConnectionAadAppRequest {
  tenantId?: string;
  clientId?: string;
  clientSecret?: string;
  server?: string;
  database?: string;
  schemaName?: string;
  /** @nullable */
  agentId?: string | null;
  $type: TestAzureSqlConnectionAadAppRequestType;
}

export type TestAzureSqlConnectionBasicRequestType =
  (typeof TestAzureSqlConnectionBasicRequestType)[keyof typeof TestAzureSqlConnectionBasicRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestAzureSqlConnectionBasicRequestType = {
  Basic: 'Basic',
} as const;

export interface TestAzureSqlConnectionBasicRequest {
  username?: string;
  password?: string;
  encryptConnection?: boolean;
  server?: string;
  database?: string;
  schemaName?: string;
  /** @nullable */
  agentId?: string | null;
  $type: TestAzureSqlConnectionBasicRequestType;
}

export type UpdateAzureSqlTargetConfigAadAppRequestType =
  (typeof UpdateAzureSqlTargetConfigAadAppRequestType)[keyof typeof UpdateAzureSqlTargetConfigAadAppRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAzureSqlTargetConfigAadAppRequestType = {
  AadApp: 'AadApp',
} as const;

export interface UpdateAzureSqlTargetConfigAadAppRequest {
  /** @nullable */
  tenantId?: string | null;
  /** @nullable */
  clientId?: string | null;
  /** @nullable */
  clientSecret?: string | null;
  /** @nullable */
  server?: string | null;
  /** @nullable */
  database?: string | null;
  /** @nullable */
  schemaName?: string | null;
  /** @nullable */
  tablePrefix?: string | null;
  $type: UpdateAzureSqlTargetConfigAadAppRequestType;
}

export type UpdateAzureSqlConfigBasicRequestType =
  (typeof UpdateAzureSqlConfigBasicRequestType)[keyof typeof UpdateAzureSqlConfigBasicRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAzureSqlConfigBasicRequestType = {
  Basic: 'Basic',
} as const;

export interface UpdateAzureSqlConfigBasicRequest {
  /** @nullable */
  username?: string | null;
  /** @nullable */
  password?: string | null;
  /** @nullable */
  encryptConnection?: boolean | null;
  /** @nullable */
  server?: string | null;
  /** @nullable */
  database?: string | null;
  /** @nullable */
  schemaName?: string | null;
  /** @nullable */
  tablePrefix?: string | null;
  $type: UpdateAzureSqlConfigBasicRequestType;
}

export type QuietTimeDailyScheduleConfigRequestType =
  (typeof QuietTimeDailyScheduleConfigRequestType)[keyof typeof QuietTimeDailyScheduleConfigRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuietTimeDailyScheduleConfigRequestType = {
  QuietTimeDaily: 'QuietTimeDaily',
} as const;

export interface QuietTimeDailyScheduleConfigRequest {
  startTime?: string;
  endTime?: string;
  $type: QuietTimeDailyScheduleConfigRequestType;
}

export type QuietTimeWeeklyScheduleConfigRequestType =
  (typeof QuietTimeWeeklyScheduleConfigRequestType)[keyof typeof QuietTimeWeeklyScheduleConfigRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuietTimeWeeklyScheduleConfigRequestType = {
  QuietTimeWeekly: 'QuietTimeWeekly',
} as const;

export interface QuietTimeWeeklyScheduleConfigRequest {
  days?: DayOfWeek[];
  startTime?: string;
  endTime?: string;
  $type: QuietTimeWeeklyScheduleConfigRequestType;
}

export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DayOfWeek = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
} as const;

export type AvailableDataverseSourceTableDtoType =
  (typeof AvailableDataverseSourceTableDtoType)[keyof typeof AvailableDataverseSourceTableDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailableDataverseSourceTableDtoType = {
  Dataverse: 'Dataverse',
} as const;

export interface AvailableDataverseSourceTableDto {
  logicalName: string;
  displayName: string;
  isEnabled: boolean;
  disabledReason?: AvailableTableDisabledReason;
  $type: AvailableDataverseSourceTableDtoType;
}

export type AvailableTableDisabledReason =
  (typeof AvailableTableDisabledReason)[keyof typeof AvailableTableDisabledReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailableTableDisabledReason = {
  ChangeTrackingDisabled: 'ChangeTrackingDisabled',
  NotSupported: 'NotSupported',
  RelatedChangeTrackingDisabled: 'RelatedChangeTrackingDisabled',
  AlreadyAdded: 'AlreadyAdded',
  VirtualTable: 'VirtualTable',
} as const;

export type AvailableBusinessCentralSourceTableDtoType =
  (typeof AvailableBusinessCentralSourceTableDtoType)[keyof typeof AvailableBusinessCentralSourceTableDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailableBusinessCentralSourceTableDtoType = {
  BusinessCentral: 'BusinessCentral',
} as const;

export interface AvailableBusinessCentralSourceTableDto {
  apiEndpoint: BcApiEndpoint;
  /** @nullable */
  dateTimeFields?: string[] | null;
  /** @nullable */
  defaultTimestampField?: string | null;
  /** @nullable */
  hasIsDeletedField?: boolean | null;
  /** @nullable */
  isDeletedFieldName?: string | null;
  logicalName: string;
  displayName: string;
  isEnabled: boolean;
  disabledReason?: AvailableTableDisabledReason;
  $type: AvailableBusinessCentralSourceTableDtoType;
}

export type AvailableSalesforceSourceTableDtoType =
  (typeof AvailableSalesforceSourceTableDtoType)[keyof typeof AvailableSalesforceSourceTableDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailableSalesforceSourceTableDtoType = {
  Salesforce: 'Salesforce',
} as const;

export interface AvailableSalesforceSourceTableDto {
  isCustom?: boolean;
  logicalName: string;
  displayName: string;
  isEnabled: boolean;
  disabledReason?: AvailableTableDisabledReason;
  $type: AvailableSalesforceSourceTableDtoType;
}

export type QuietTimeDailyScheduleDtoType =
  (typeof QuietTimeDailyScheduleDtoType)[keyof typeof QuietTimeDailyScheduleDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuietTimeDailyScheduleDtoType = {
  QuietTimeDaily: 'QuietTimeDaily',
} as const;

export interface QuietTimeDailyScheduleDto {
  startTime: string;
  endTime: string;
  id: string;
  profileId: string;
  createdUtc: string;
  $type: QuietTimeDailyScheduleDtoType;
}

export type QuietTimeWeeklyScheduleDtoType =
  (typeof QuietTimeWeeklyScheduleDtoType)[keyof typeof QuietTimeWeeklyScheduleDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuietTimeWeeklyScheduleDtoType = {
  QuietTimeWeekly: 'QuietTimeWeekly',
} as const;

export interface QuietTimeWeeklyScheduleDto {
  days: DayOfWeek[];
  startTime: string;
  endTime: string;
  id: string;
  profileId: string;
  createdUtc: string;
  $type: QuietTimeWeeklyScheduleDtoType;
}

export type DataverseSourceDtoType =
  (typeof DataverseSourceDtoType)[keyof typeof DataverseSourceDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataverseSourceDtoType = {
  Dataverse: 'Dataverse',
} as const;

export interface DataverseSourceDto {
  baseUrl: string;
  clientId: string;
  clientSecretSecretName: string;
  pageSize: number;
  dataverseLookupLabelMaxLength: number;
  dataverseChoiceLabelMaxLength: number;
  dataverseMultiSelectMaxLength: number;
  id: string;
  profileId: string;
  createdUtc: string;
  connectionStatus: ConnectionStatus;
  /** @nullable */
  connectionLastCheckedUtc?: string | null;
  $type: DataverseSourceDtoType;
}

export type ConnectionStatus = (typeof ConnectionStatus)[keyof typeof ConnectionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConnectionStatus = {
  Failed: 'Failed',
  Success: 'Success',
} as const;

export type BusinessCentralSourceDtoType =
  (typeof BusinessCentralSourceDtoType)[keyof typeof BusinessCentralSourceDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessCentralSourceDtoType = {
  BusinessCentral: 'BusinessCentral',
} as const;

export interface BusinessCentralSourceDto {
  tenantId: string;
  environment: string;
  clientId: string;
  clientSecretSecretName: string;
  companyId: string;
  companyName: string;
  pageSize: number;
  id: string;
  profileId: string;
  createdUtc: string;
  connectionStatus: ConnectionStatus;
  /** @nullable */
  connectionLastCheckedUtc?: string | null;
  $type: BusinessCentralSourceDtoType;
}

export type SalesforceSourceDtoType =
  (typeof SalesforceSourceDtoType)[keyof typeof SalesforceSourceDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SalesforceSourceDtoType = {
  Salesforce: 'Salesforce',
} as const;

export interface SalesforceSourceDto {
  instanceUrl: string;
  isSandbox?: boolean;
  clientId: string;
  clientSecretSecretName: string;
  pageSize: number;
  /** @nullable */
  isBulkApiAvailable?: boolean | null;
  id: string;
  profileId: string;
  createdUtc: string;
  connectionStatus: ConnectionStatus;
  /** @nullable */
  connectionLastCheckedUtc?: string | null;
  /** @nullable */
  restApiUsagePercent?: number | null;
  /** @nullable */
  restApiUsageCheckedUtc?: string | null;
  $type: SalesforceSourceDtoType;
}

export type DataverseSourceTableDtoType =
  (typeof DataverseSourceTableDtoType)[keyof typeof DataverseSourceTableDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataverseSourceTableDtoType = {
  Dataverse: 'Dataverse',
} as const;

export interface DataverseSourceTableDto {
  id: string;
  sourceId: string;
  logicalName: string;
  /** @nullable */
  displayName?: string | null;
  isEnabled: boolean;
  disabledReason?: SourceTableDisabledReason;
  hasInitialSyncCompleted: boolean;
  $type: DataverseSourceTableDtoType;
}

export type SourceTableDisabledReason =
  (typeof SourceTableDisabledReason)[keyof typeof SourceTableDisabledReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceTableDisabledReason = {
  ByUser: 'ByUser',
  PersistentFailure: 'PersistentFailure',
  NotSupported: 'NotSupported',
  ChangeTrackingRequired: 'ChangeTrackingRequired',
} as const;

export type BusinessCentralSourceTableDtoType =
  (typeof BusinessCentralSourceTableDtoType)[keyof typeof BusinessCentralSourceTableDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessCentralSourceTableDtoType = {
  BusinessCentral: 'BusinessCentral',
} as const;

export interface BusinessCentralSourceTableDto {
  apiEndpoint: BcApiEndpoint;
  /** @nullable */
  timestampField?: string | null;
  /** @nullable */
  hasIsDeletedField?: boolean | null;
  /** @nullable */
  isDeletedFieldName?: string | null;
  /** @nullable */
  lastInventorySyncUtc?: string | null;
  id: string;
  sourceId: string;
  logicalName: string;
  /** @nullable */
  displayName?: string | null;
  isEnabled: boolean;
  disabledReason?: SourceTableDisabledReason;
  hasInitialSyncCompleted: boolean;
  $type: BusinessCentralSourceTableDtoType;
}

export type SalesforceSourceTableDtoType =
  (typeof SalesforceSourceTableDtoType)[keyof typeof SalesforceSourceTableDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SalesforceSourceTableDtoType = {
  Salesforce: 'Salesforce',
} as const;

export interface SalesforceSourceTableDto {
  /** @nullable */
  timestampField?: string | null;
  /** @nullable */
  isDeletedFieldName?: string | null;
  id: string;
  sourceId: string;
  logicalName: string;
  /** @nullable */
  displayName?: string | null;
  isEnabled: boolean;
  disabledReason?: SourceTableDisabledReason;
  hasInitialSyncCompleted: boolean;
  $type: SalesforceSourceTableDtoType;
}

export type AzureSqlTargetDtoType =
  (typeof AzureSqlTargetDtoType)[keyof typeof AzureSqlTargetDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AzureSqlTargetDtoType = {
  AzureSql: 'AzureSql',
} as const;

export interface AzureSqlTargetDto {
  tenantId: string;
  clientId: string;
  clientSecretSecretName: string;
  server: string;
  database: string;
  schemaName: string;
  /** @nullable */
  tablePrefix?: string | null;
  id: string;
  profileId: string;
  createdUtc: string;
  connectionStatus: ConnectionStatus;
  /** @nullable */
  connectionLastCheckedUtc?: string | null;
  /** @nullable */
  agentId?: string | null;
  $type: AzureSqlTargetDtoType;
}

export type AzureSqlCredentialTargetDtoType =
  (typeof AzureSqlCredentialTargetDtoType)[keyof typeof AzureSqlCredentialTargetDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AzureSqlCredentialTargetDtoType = {
  AzureSqlCredential: 'AzureSqlCredential',
} as const;

export interface AzureSqlCredentialTargetDto {
  username: string;
  passwordSecretName: string;
  encryptConnection?: boolean;
  server: string;
  database: string;
  schemaName: string;
  /** @nullable */
  tablePrefix?: string | null;
  id: string;
  profileId: string;
  createdUtc: string;
  connectionStatus: ConnectionStatus;
  /** @nullable */
  connectionLastCheckedUtc?: string | null;
  /** @nullable */
  agentId?: string | null;
  $type: AzureSqlCredentialTargetDtoType;
}

export type ExecuteSqlPayloadType =
  (typeof ExecuteSqlPayloadType)[keyof typeof ExecuteSqlPayloadType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExecuteSqlPayloadType = {
  ExecuteSql: 'ExecuteSql',
} as const;

export interface ExecuteSqlPayload {
  command?: string;
  commandTimeoutSeconds?: number;
  server: string;
  database: string;
  credential: SqlCredential;
  encryptConnection?: boolean;
  $type: ExecuteSqlPayloadType;
}

export type SqlCredential = AccessTokenCredential | BasicCredential;

export type SqlBulkLoadPagePayloadType =
  (typeof SqlBulkLoadPagePayloadType)[keyof typeof SqlBulkLoadPagePayloadType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SqlBulkLoadPagePayloadType = {
  SqlBulkLoadPage: 'SqlBulkLoadPage',
} as const;

export interface SqlBulkLoadPagePayload {
  blobPath?: string;
  blobSasUrl?: string;
  entityMappings?: EntityMapping[];
  batchSize?: number;
  server: string;
  database: string;
  credential: SqlCredential;
  encryptConnection?: boolean;
  $type: SqlBulkLoadPagePayloadType;
}

export interface EntityMapping {
  targetTable?: string;
  targetSchema?: string;
  columnMappings?: ColumnMapping[];
  /** @nullable */
  filterExpression?: string | null;
  /** @nullable */
  batchSize?: number | null;
}

export interface ColumnMapping {
  sourceColumn?: string;
  targetColumn?: string;
  sqlType?: string;
}

export type AccessTokenCredentialType =
  (typeof AccessTokenCredentialType)[keyof typeof AccessTokenCredentialType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessTokenCredentialType = {
  AccessToken: 'AccessToken',
} as const;

export interface AccessTokenCredential {
  accessToken: string;
  tenantId: string;
  clientId: string;
  secretName: string;
  $type: AccessTokenCredentialType;
}

export type BasicCredentialType = (typeof BasicCredentialType)[keyof typeof BasicCredentialType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BasicCredentialType = {
  Basic: 'Basic',
} as const;

export interface BasicCredential {
  username: string;
  password: string;
  secretName: string;
  $type: BasicCredentialType;
}

export type GetAgentLogsParams = {
  /**
   * Number of entries per page (1–100, default 50)
   */
  limit?: number;
  /**
   * Continuation token from the previous page
   */
  continuationToken?: string;
};

export type GetAgentTasksParams = {
  /**
   * Task status filter (e.g. Running, Pending)
   */
  status: string;
};

export type PostProfileSync200 = { [key: string]: unknown };

export type PutSources200 = { [key: string]: unknown };

export type PutSourceTableState200 = { [key: string]: unknown };

export type DeleteSourceTablesById200 = { [key: string]: unknown };

export type PostSourceTableSync200 = { [key: string]: unknown };

export type PatchTargetsById200 = { [key: string]: unknown };

export interface CreateSupportCommentRequest {
  comment?: string;
  attachmentIds?: string[];
}

export type CreateSupportTicketRequestPriority =
  (typeof CreateSupportTicketRequestPriority)[keyof typeof CreateSupportTicketRequestPriority];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSupportTicketRequestPriority = {
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  Critical: 'Critical',
} as const;

export type CreateSupportTicketRequestCategory =
  (typeof CreateSupportTicketRequestCategory)[keyof typeof CreateSupportTicketRequestCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSupportTicketRequestCategory = {
  Support: 'Support',
  DataWrangler: 'DataWrangler',
} as const;

export interface CreateSupportTicketRequest {
  title?: string;
  description?: string;
  priority?: CreateSupportTicketRequestPriority;
  category?: CreateSupportTicketRequestCategory;
}

export interface PagedResultSupportTicketSummaryDto {
  items?: SupportTicketSummaryDto[];
  totalCount?: number;
  page?: number;
  pageSize?: number;
  totalPages?: number;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
}

export type SupportAttachmentDtoScanStatus =
  (typeof SupportAttachmentDtoScanStatus)[keyof typeof SupportAttachmentDtoScanStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportAttachmentDtoScanStatus = {
  Pending: 'Pending',
  Clean: 'Clean',
  Unavailable: 'Unavailable',
} as const;

export interface SupportAttachmentDto {
  id?: string;
  fileName?: string;
  fileType?: string;
  fileSize?: number;
  uploadedAt?: string;
  uploadedBy?: SupportPersonDto;
  scanStatus?: SupportAttachmentDtoScanStatus;
  /** @nullable */
  commentId?: string | null;
  isInline?: boolean;
}

export interface SupportAttachmentPolicyDto {
  maxBytes?: number;
  allowedExtensions?: string[];
  blockedExtensions?: string[];
  fileNameMaxLength?: number;
}

/**
 * @nullable
 */
export type SupportAttachmentUnavailableProblemDetailsScanStatus =
  | (typeof SupportAttachmentUnavailableProblemDetailsScanStatus)[keyof typeof SupportAttachmentUnavailableProblemDetailsScanStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportAttachmentUnavailableProblemDetailsScanStatus = {
  Pending: 'Pending',
  Clean: 'Clean',
  Unavailable: 'Unavailable',
} as const;

export interface SupportAttachmentUnavailableProblemDetails {
  /** @nullable */
  scanStatus?: SupportAttachmentUnavailableProblemDetailsScanStatus;
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
}

export interface SupportAttachmentUploadForm {
  file?: Blob;
}

export type SupportCommentDtoContentFormat =
  (typeof SupportCommentDtoContentFormat)[keyof typeof SupportCommentDtoContentFormat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportCommentDtoContentFormat = {
  Text: 'Text',
  Html: 'Html',
} as const;

export interface SupportCommentDto {
  id?: string;
  comment?: string;
  createdAt?: string;
  author?: SupportPersonDto;
  contentFormat?: SupportCommentDtoContentFormat;
  needsCustomerReply?: boolean;
  attachmentIds?: string[];
}

export interface SupportLastActivityDto {
  at?: string;
  author?: SupportPersonDto;
}

export interface SupportPartnerDto {
  partnerOrgId?: string;
  name?: string;
  description?: string;
  primaryEmail?: string;
  phoneNumber?: string;
  website?: string;
  city?: string;
  stateProvince?: string;
  country?: string;
  hasLogo?: boolean;
  /** @nullable */
  logoUpdatedAt?: string | null;
  logoUrl?: string;
  hasDarkLogo?: boolean;
  /** @nullable */
  darkLogoUpdatedAt?: string | null;
  darkLogoUrl?: string;
}

export type SupportPersonDtoType = (typeof SupportPersonDtoType)[keyof typeof SupportPersonDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportPersonDtoType = {
  Customer: 'Customer',
  Support: 'Support',
  AI: 'AI',
} as const;

export interface SupportPersonDto {
  type?: SupportPersonDtoType;
  authUserId?: string;
  displayName?: string;
  isCurrentUser?: boolean;
}

export interface SupportTicketCountsDto {
  open?: number;
  needsReply?: number;
  closed?: number;
  total?: number;
}

export type SupportTicketDetailDtoStatus =
  (typeof SupportTicketDetailDtoStatus)[keyof typeof SupportTicketDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketDetailDtoStatus = {
  Open: 'Open',
  InProgress: 'InProgress',
  Resolved: 'Resolved',
  Closed: 'Closed',
} as const;

export type SupportTicketDetailDtoPriority =
  (typeof SupportTicketDetailDtoPriority)[keyof typeof SupportTicketDetailDtoPriority];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketDetailDtoPriority = {
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  Critical: 'Critical',
} as const;

export type SupportTicketDetailDtoCategory =
  (typeof SupportTicketDetailDtoCategory)[keyof typeof SupportTicketDetailDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketDetailDtoCategory = {
  Support: 'Support',
  DataWrangler: 'DataWrangler',
} as const;

/**
 * @nullable
 */
export type SupportTicketDetailDtoResolutionCategory =
  | (typeof SupportTicketDetailDtoResolutionCategory)[keyof typeof SupportTicketDetailDtoResolutionCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketDetailDtoResolutionCategory = {
  Bug: 'Bug',
  Knowledge: 'Knowledge',
  Enhancement: 'Enhancement',
  DataWrangler: 'DataWrangler',
} as const;

export interface SupportTicketDetailDto {
  description?: string;
  comments?: SupportCommentDto[];
  attachments?: SupportAttachmentDto[];
  id?: string;
  title?: string;
  status?: SupportTicketDetailDtoStatus;
  priority?: SupportTicketDetailDtoPriority;
  category?: SupportTicketDetailDtoCategory;
  /** @nullable */
  resolutionCategory?: SupportTicketDetailDtoResolutionCategory;
  needsCustomerReply?: boolean;
  lastActivity?: SupportLastActivityDto;
  createdAt?: string;
  /** @nullable */
  modifiedAt?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
  submitter?: SupportPersonDto;
  commentCount?: number;
  attachmentCount?: number;
}

export type SupportTicketSummaryDtoStatus =
  (typeof SupportTicketSummaryDtoStatus)[keyof typeof SupportTicketSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketSummaryDtoStatus = {
  Open: 'Open',
  InProgress: 'InProgress',
  Resolved: 'Resolved',
  Closed: 'Closed',
} as const;

export type SupportTicketSummaryDtoPriority =
  (typeof SupportTicketSummaryDtoPriority)[keyof typeof SupportTicketSummaryDtoPriority];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketSummaryDtoPriority = {
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  Critical: 'Critical',
} as const;

export type SupportTicketSummaryDtoCategory =
  (typeof SupportTicketSummaryDtoCategory)[keyof typeof SupportTicketSummaryDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketSummaryDtoCategory = {
  Support: 'Support',
  DataWrangler: 'DataWrangler',
} as const;

/**
 * @nullable
 */
export type SupportTicketSummaryDtoResolutionCategory =
  | (typeof SupportTicketSummaryDtoResolutionCategory)[keyof typeof SupportTicketSummaryDtoResolutionCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketSummaryDtoResolutionCategory = {
  Bug: 'Bug',
  Knowledge: 'Knowledge',
  Enhancement: 'Enhancement',
  DataWrangler: 'DataWrangler',
} as const;

export interface SupportTicketSummaryDto {
  id?: string;
  title?: string;
  status?: SupportTicketSummaryDtoStatus;
  priority?: SupportTicketSummaryDtoPriority;
  category?: SupportTicketSummaryDtoCategory;
  /** @nullable */
  resolutionCategory?: SupportTicketSummaryDtoResolutionCategory;
  needsCustomerReply?: boolean;
  lastActivity?: SupportLastActivityDto;
  createdAt?: string;
  /** @nullable */
  modifiedAt?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
  submitter?: SupportPersonDto;
  commentCount?: number;
  attachmentCount?: number;
}

export type GetSupportPartnerLogoParams = {
  /**
   * Optional cache-busting version (e.g. the logo's last update time). Ignored by the server.
   */
  v?: string;
};

export type GetSupportPartnerDarkLogoParams = {
  /**
   * Optional cache-busting version (e.g. the logo's last update time). Ignored by the server.
   */
  v?: string;
};

export type GetSupportTicketsParams = {
  /**
   * Only return tickets with this status
   */
  status?: GetSupportTicketsStatus;
  /**
   * Only return tickets in this status group: Open (open or in progress), NeedsReply (waiting on the customer) or Closed (resolved or closed)
   */
  statusGroup?: GetSupportTicketsStatusGroup;
  /**
   * The 1-based page number (default 1)
   */
  page?: number;
  /**
   * The page size (default 25, max 100)
   */
  pageSize?: number;
};

export type GetSupportTicketsStatus =
  (typeof GetSupportTicketsStatus)[keyof typeof GetSupportTicketsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSupportTicketsStatus = {
  open: 'open',
  inProgress: 'inProgress',
  resolved: 'resolved',
  closed: 'closed',
} as const;

export type GetSupportTicketsStatusGroup =
  (typeof GetSupportTicketsStatusGroup)[keyof typeof GetSupportTicketsStatusGroup];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSupportTicketsStatusGroup = {
  open: 'open',
  needsReply: 'needsReply',
  closed: 'closed',
} as const;